/* ============================================================
   Версія сайту для сторінки запису: чоловіча (cleanhands.club)
   чи жіноча (w.cleanhands.club). Від неї залежать фон, логотип,
   підпис і куди повертаємо гостя після запису. Бекенд не залежить.

   Порядок визначення:
     1) ?v=w | ?v=m у посиланні (лендінг жіночої студії веде на /book?v=w)
     2) document.referrer — з якого лендінгу прийшли (запасний варіант)
     3) збережений раніше вибір (localStorage)
     4) за замовчуванням — чоловіча (поведінка як і раніше)
   ============================================================ */

const STORAGE_KEY = 'chc-site-variant';

export const SITE_VARIANTS = {
  m: {
    id: 'm',
    // sx для фонового шару сторінки запису (MUI, можна адаптивно {xs, md})
    backgroundSx: {
      backgroundImage: 'linear-gradient(rgba(10,9,7,0.58), rgba(10,9,7,0.8)), url(/booking-bg.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    logo: '/logo-chc.png',
    taglineKey: 'brand.taglineMen',
    landingUrl: process.env.REACT_APP_LANDING_URL || 'http://localhost:5173',
  },
  w: {
    id: 'w',
    // Те саме фото, що й у hero жіночого лендінгу
    // (clean-hands-club-women/src/assets/images/hero-women.jpg) — міняти разом.
    // Mobile: як на лендінгу — фото зверху (~62% висоти) і плавно переходить у темний фон,
    // щоб було видно всю сцену, а не збільшені пальці. Desktop: на весь екран.
    backgroundSx: {
      backgroundColor: '#090b08',
      backgroundRepeat: 'no-repeat',
      backgroundImage: {
        xs: 'linear-gradient(180deg, rgba(9,11,8,0.45) 0, rgba(9,11,8,0.25) 14vh, rgba(9,11,8,0.55) 40vh, #090b08 62vh), url(/booking-bg-women.jpg)',
        md: 'linear-gradient(rgba(9,11,8,0.35), rgba(9,11,8,0.6) 45%, rgba(9,11,8,0.85)), url(/booking-bg-women.jpg)',
      },
      backgroundSize: { xs: 'auto 62vh', md: 'cover' },
      backgroundPosition: { xs: '64% 0', md: 'center' },
    },
    logo: '/logo-chc-women.png',
    taglineKey: 'brand.taglineWomen',
    landingUrl: process.env.REACT_APP_LANDING_URL_WOMEN || 'http://localhost:5174',
  },
};

const DEFAULT_VARIANT = 'm';

const hostOf = (url) => {
  try {
    return new URL(url).host;
  } catch {
    return '';
  }
};

function fromQuery() {
  const v = new URLSearchParams(window.location.search).get('v');
  return SITE_VARIANTS[v] ? v : null;
}

// Лише якщо прийшли саме з одного з лендінгів (а не з самого app чи стороннього сайту)
function fromReferrer() {
  const ref = hostOf(document.referrer);
  if (!ref) return null;
  if (ref === hostOf(SITE_VARIANTS.w.landingUrl)) return 'w';
  if (ref === hostOf(SITE_VARIANTS.m.landingUrl)) return 'm';
  return null;
}

function readStored() {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return SITE_VARIANTS[v] ? v : null;
  } catch {
    return null;
  }
}

function store(v) {
  try {
    window.localStorage.setItem(STORAGE_KEY, v);
  } catch {
    /* private mode — ігноруємо */
  }
}

/** Визначає версію при вході на сторінку запису і запам'ятовує її. */
export function resolveSiteVariant() {
  const explicit = fromQuery() || fromReferrer();
  if (explicit) store(explicit);
  return SITE_VARIANTS[explicit || readStored() || DEFAULT_VARIANT];
}

/** Поточна (вже визначена) версія — напр. для сторінки «запис створено». */
export function currentSiteVariant() {
  return SITE_VARIANTS[readStored() || DEFAULT_VARIANT];
}
